import { styled } from "@mui/material/styles";

const FilterButtonsWrapper = styled("div")(({ theme }) => ({
  width: "65%",
  margin: "0 auto",

  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
}));

export { FilterButtonsWrapper };
